import React from "react";
import "./IA.css";
import TarjetaDeServicio from "./components/TarjetaDeServicioIa";
import GestionIa from "./components/GestionIa";
import { useTranslation } from "react-i18next";

interface ServiceItem {
  title: string;
  desc: string;
}

export default function IA() {
  const { t } = useTranslation();

  const services: ServiceItem[] = [
    {
      title: t("pages.ia.services.0.title"),
      desc: t("pages.ia.services.0.desc"),
    },
    {
      title: t("pages.ia.services.1.title"),
      desc: t("pages.ia.services.1.desc"),
    },
    {
      title: t("pages.ia.services.2.title"),
      desc: t("pages.ia.services.2.desc"),
    },
    {
      title: t("pages.ia.services.3.title"),
      desc: t("pages.ia.services.3.desc"),
    },
  ];

  return (
    <>
      <section
        className="fondo-ia"
        style={{
          backgroundImage: 'url("/9142834.webp")',
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          position: "relative",
          minHeight: "60vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        } as React.CSSProperties}
      >
        <div className="ia-overlay">
          <h1 className="ia-titulo">{t("pages.ia.title")}</h1>
          <p className="ia-descripcion">{t("pages.ia.description")}</p>
        </div>
      </section>

      <h2 className="ia-subtitulo">{t("pages.ia.benefits_title")}</h2>

      <div className="ia-card-grid">
        {services.map((service, index) => (
          <TarjetaDeServicio
            key={index}
            service={service}
            animationClass="from-bottom"
            delay={index * 0.2}
          />
        ))}
      </div>

      <GestionIa
        gestion={[
          {
            titulo: t("pages.ia.gestion.0.titulo"),
            descripcion: t("pages.ia.gestion.0.descripcion"),
          },
          {
            titulo: t("pages.ia.gestion.1.titulo"),
            descripcion: t("pages.ia.gestion.1.descripcion"),
          },
          {
            titulo: t("pages.ia.gestion.2.titulo"),
            descripcion: t("pages.ia.gestion.2.descripcion"),
          },
          {
            titulo: t("pages.ia.gestion.3.titulo"),
            descripcion: t("pages.ia.gestion.3.descripcion"),
          },
        ]}
        alcance={[
          { titulo: t("pages.ia.alcance.0.titulo") },
          { titulo: t("pages.ia.alcance.1.titulo") },
          { titulo: t("pages.ia.alcance.2.titulo") },
          { titulo: t("pages.ia.alcance.3.titulo") },
        ]}
      />
    </>
  );
}
